import React from "react";
import { Link } from "react-router-dom";
import localeText from "../../../locale";
import ConfimeaHeader from "./ConfimeaHeader";
import ConfimeaFooter from "./ConfimeaFooter";

const ConfimeaConfirmationError = ({ error }) => {
  return (
    <div className="confimea-confirmation-page">
      <ConfimeaHeader />
      <div className="confimea-confirmation-container">
        <div className="confimea-confirmation-card">
          <div className="text-center">
            <i className="pi pi-times-circle text-6xl text-red-500 my-6"></i>
            <h2 className="confimea-confirmation-error-title">{localeText("error")}</h2>
            <p className="confimea-confirmation-error-message">{error}</p>
            <Link to="/login" className="confimea-btn confimea-btn-primary mt-4">
              {localeText("goToLogin")}
            </Link>
          </div>
        </div>
      </div>
      <ConfimeaFooter />
    </div>
  );
};

export default ConfimeaConfirmationError;

